import { Injectable } from '@angular/core';
import { HttpService } from "./http.service";
import { RegisterResultViewModel } from "../models/register-result-view-model";
import { UserViewModel } from "../models/user-view-model";
import { CreateResult } from '../models/create-result';
import { SearchFilterModel } from '../models/search-filter-model';
import { PagedResponse } from '../models/paged-response';
import { ClientViewModel } from '../models/client-view-model';


@Injectable({
  providedIn: 'root'
})
export class UserManagementService {

  constructor(private _httpService: HttpService) {
  }

  public async GetParticipantUsers(): Promise<UserViewModel[]> {
    const httpResult = await this._httpService.apiGet<UserViewModel[]>(`UserManagement/list`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return []
  }

  public async GetPagedParticipantUsers(filter: SearchFilterModel): Promise<PagedResponse<UserViewModel>> {
    const httpResult = await this._httpService.apiPost<PagedResponse<UserViewModel>>(`UserManagement/list-paged`, filter);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return {
      response: null,
      total: 0
    };
  }

  public async GetParticipantUsersByActivity(take: number, skip: number): Promise<UserViewModel[]> {
    const httpResult = await this._httpService.apiGet<UserViewModel[]>(`UserManagement/listByActivity/${take}/${skip}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return []
  }

  public async GetAllUsers(): Promise<UserViewModel[]> {
    const httpResult = await this._httpService.apiGet<UserViewModel[]>(`UserManagement/all`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return []
  }

  public async GetPagedUsers(filter: SearchFilterModel): Promise<PagedResponse<UserViewModel>> {
    const httpResult = await this._httpService.apiPost<PagedResponse<UserViewModel>>(`UserManagement/paged`, filter);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return {
      response: null,
      total: 0
    };
  }

  public async GetByUserId(userId: string): Promise<UserViewModel> {

    const httpResult = await this._httpService.apiGet<UserViewModel>(`UserManagement/GetByUser/${userId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }

    return null;
  }

  public async GetUsersByRole(roleId: string): Promise<UserViewModel[]> {
    const httpResult = await this._httpService.apiGet<UserViewModel[]>(`UserManagement/listByRole/${roleId}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return []
  }

  public async AddNewParticipantUser(user: UserViewModel): Promise<RegisterResultViewModel> {
    const httpResult = await this._httpService.apiPost<RegisterResultViewModel>(`UserManagement/AddUser`, user);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return {
      success: false,
      message: "An Unknown Error has occured"
    };
  }

  public async SendActivationEmail(user: UserViewModel): Promise<CreateResult> {
    const httpResult = await this._httpService.apiPost<CreateResult>(`UserManagement/SendActivationEmail`, user);

    if (httpResult && httpResult.body) {
        return { message: httpResult.body.message, success: httpResult.body.success };
    }

    return {
      success: false,
      message: httpResult.body.message
    };
  }

  public async UpdateParticipantUser(user: UserViewModel): Promise<RegisterResultViewModel> {
    const httpResult = await this._httpService.apiPost<RegisterResultViewModel>(`UserManagement/UpdateUser`, user);

    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return {
      success: false,
      message: "An Unknown Error has occured"
    };
  }

  public async DeleteParticipantUser(user: UserViewModel): Promise<RegisterResultViewModel> {
    const httpResult = await this._httpService.apiPost<RegisterResultViewModel>(`UserManagement/DeleteUser`, user);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return {
      success: false,
      message: "An Unknown Error has occured"
    };
  }

  public async ForgotPassword(email: string): Promise<{ success: boolean, message: string }> {
    const httpResult = await this._httpService.apiPost<CreateResult>(`UserManagement/ForgotPassword/${email}`, email);
    if (httpResult && httpResult.body.success === true) {
      return httpResult.body;
    }
    else {
      return httpResult.body;
    }
  }

  public async Generate2FASetup(userId: string): Promise<any> {
    return this._httpService.apiGet<any>(`authentication/setup-2fa/${userId}`);
  }


  public async VerifyAndEnable2FA(payload: { userId: string, otpCode: string, secretKey: string }): Promise<any> {
    debugger;
    try {
      const response = await this._httpService.apiPost<any>(
        `authentication/verify-and-enable-2fa`,
        payload
      );
      return response; // Make sure this matches your HTTP service response structure
    } catch (error) {
      // Handle error appropriately
      throw error;
    }
  }
  public async Disable2FA(userId: string): Promise<any> {
    return this._httpService.apiGet<any>(`authentication/disable-2fa/${userId}`);
  }
}
